import * as status from 'http-status-codes';
import { Auth } from '@trustpilot/ecommscript-integrationappauth/external-authentication';
import { AxiosResponse } from 'axios';
import { store } from './store';
import { App as actions } from './Actions';

export class Tools {
    public static compareVersions(v1: string, v2: string, operator: string) {
        let compare = 0;
        const v1parts = v1.split('.').map(Number);
        const v2parts = v2.split('.').map(Number);
        for (let i = 0; i < v1parts.length; ++i) {
            if (v2parts.length === i) {
                compare = 1;
                break;
            }
            if (v1parts[i] === v2parts[i]) {
                continue;
            } else if (v1parts[i] > v2parts[i]) {
                compare = 1;
                break;
            } else {
                compare = -1;
                break;
            }
        }

        if (v1parts.length !== v2parts.length) {
            compare = -1;
        }

        switch (operator) {
            case '>':
            case 'gt':
                return (compare > 0);
            case '>=':
            case 'ge':
                return (compare >= 0);
            case '<=':
            case 'le':
                return (compare <= 0);
            case '===':
            case '=':
            case 'eq':
                return (compare === 0);
            case '<>':
            case '!==':
            case 'ne':
                return (compare !== 0);
            case '':
            case '<':
            case 'lt':
                return (compare < 0);
            default:
                return null;
        }
    }

    public static resetTokenIfUnauthorized(response?: AxiosResponse, failedUnitId?: string) {
        if (response && [status.UNAUTHORIZED, status.FORBIDDEN].includes(response.status)) {
            Auth.removeTokens(process.env.REACT_APP_CookiesDomain!);
            if (response.status === status.FORBIDDEN) {
                const { App: { account: { businessUnitId } } } = store.getState();
                store.dispatch(actions.setAccessError(failedUnitId || businessUnitId));
            } else {
                window.location.reload();
            }
        }
    }
}
